import React, { useContext } from "react";
import "./StartupProjects.scss";
import { bigProjects } from "../../portfolio";
import { Fade } from "react-reveal";
import StyleContext from "../../contexts/StyleContext";
import LanguageContext from "../../contexts/LanguageContext";
import { translations } from "../../translations";

export default function StartupProject() {
  function openUrlInNewTab(url) {
    if (!url) {
      return;
    }
    var win = window.open(url, "_blank");
    win.focus();
  }

  const { isDark } = useContext(StyleContext);
  const { isEnglish } = useContext(LanguageContext);
  const currentLang = isEnglish ? translations.en : translations.pt;
  return (
    <div id="projects">
      <Fade bottom duration={300} distance="20px">
        <div className="main" id="projects">
          <div>
            <h1 className="projects-header">{currentLang.projects.title}</h1>
            <div className="projects-container">
              {bigProjects.projects.map((project, i) => (
                <div
                  key={i}
                  className={
                    isDark
                      ? "dark-mode project-card project-card-dark"
                      : "project-card project-card-light"
                  }
                >
                  {project.image ? (
                    <div
                      className="project-image"
                      onClick={() => openUrlInNewTab(project.footerLink[0].url)}
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        src={project.image}
                        alt={project.projectName}
                        className="card-image"
                      />
                    </div>
                  ) : null}
                  <div className="project-detail">{project.projectName}</div>
                  {project.role || project.roleEn ? (
                    <div className="project-role">
                      {isEnglish ? project.roleEn || project.role : project.role}
                    </div>
                  ) : null}
                  {project.projectDesc || project.projectDescEn ? (
                    <p
                      className={
                        isDark ? "dark-mode project-desc" : "project-desc"
                      }
                    >
                      {isEnglish
                        ? project.projectDescEn || project.projectDesc
                        : project.projectDesc}
                    </p>
                  ) : null}
                  {project.stack ? (
                    <div className="project-stack">
                      {project.stack.map((tech, i) => (
                        <span key={i} className="project-stack-pill">
                          {tech}
                        </span>
                      ))}
                    </div>
                  ) : null}
                  {project.footerLink ? (
                    <div className="project-card-footer">
                      {project.footerLink.map((link, i) => (
                        <span
                          key={i}
                          className={
                            isDark ? "dark-mode project-tag" : "project-tag"
                          }
                          onClick={() => openUrlInNewTab(link.url)}
                        >
                          {isEnglish ? link.nameEn : link.name}
                        </span>
                      ))}
                    </div>
                  ) : null}
                </div>
              ))}
            </div>
            <div className="more-projects">
              <a
                className={isDark ? "dark-mode more-projects-link" : "more-projects-link"}
                href="https://github.com/matfurrier"
                target="_blank"
                rel="noopener noreferrer"
              >
                {currentLang.projects.moreProjects}
              </a>
            </div>
          </div>
        </div>
      </Fade>
    </div>
  );
}
